import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import {MatSort, Sort} from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { OrderListMapperI } from '../../models/Orders/order-list';
import { KeyValueI, KeyValue } from '../../models/common';
import * as moment from 'moment';
@Component({
  selector: 'antera-software-list-view',
  templateUrl: './kanban-list-view.component.html',
  styleUrls: ['./kanban-list-view.component.scss'],
})
export class KanbanOrderListViewComponent implements OnInit {
  @ViewChild(MatSort) public sort: MatSort = {} as MatSort;

  @Input() public listDataSource: any[] = [];
  @Input() public displayedColumns: string[] = [];
  @Input() public pageSizeOptions: number[] = [];
  @Input() public tableLength: number = 0;
  @Input() public page: string = '';
  @Input() public displayActionsBar: boolean = false;
  @Input() public dateFormatString: string = 'YYYY-MM-DD';
  @Input() public timeFormatString: string = 'hh:mm a';
  @Input() public mappingFields: any[] = [];

  @Output() public selectClicked: EventEmitter<any> = new EventEmitter();
  @Output() public onFavoriteToggle: EventEmitter<any> = new EventEmitter();
  @Output() public onColumnClick: EventEmitter<any> = new EventEmitter();
  @Output() public onPaginateFire: EventEmitter<any> = new EventEmitter();
  @Output() public onSortFired: EventEmitter<any> = new EventEmitter();
  @Output() public onResyncQBOStatus: EventEmitter<any> = new EventEmitter();

  public totalColumnDropdownList: KeyValueI[] = [];
  public dataSource: any;
  public selectAll: boolean = false;
  public readonly colors: any = {
    Void: 'color-red-500',
    Pending: 'color-orange-500',
    Booked: 'color-blue-500',
    BackOrdered: 'color-pink-500',
    Partial: 'color-purple-500',
    Paid: 'color-blue-500',
    Unpaid: 'color-orange-500',
  };
  public pageSize: number = 50;
  public totalPriceSelectedColumn: KeyValue = {key: 'Total', value: 'totalPrice'};

  constructor() {}

  public ngOnInit(): void {
    this.dataSource = new MatTableDataSource(this.listDataSource);
    this.appendColumns();

    if(this.page === 'Orders'){
      this.totalColumnDropdownList = [{key: 'Revenue', value: 'orderAmount'}, {key: 'Total', value: 'totalPrice'}, { key: 'Balance', value: 'balance'} ];
    } else if(this.page === 'Quotes') {
      this.totalColumnDropdownList = [{key: 'Total', value: 'totalPrice'}, { key: 'Balance', value: 'balance'} ];
    }
  }

  public ngOnChanges() {
    this.appendColumns();
    this.dataSource = new MatTableDataSource(this.listDataSource);
  }

  /**
   * This method attaches the select column no
   * matter what is passed into display columns
   *
   * @returns {void}
   */
  public appendColumns(){
    const standardColumns = ['select']

    standardColumns?.forEach((colName) => {
      if(!this.displayedColumns?.includes(colName)){
        this.displayedColumns.unshift(colName);
      }
    });
  }

  /**
   * Toggles, so all checkboxes are selected.
   *
   * @returns {void}
   */
  public toggleAll(selectType: string, checkbox?: MatCheckbox, selectedRow?: OrderListMapperI ): void {

    switch (selectType){
      case 'SINGLE':
        this.dataSource.data.find((row: OrderListMapperI) => row.id === selectedRow?.id).select = checkbox?.checked;
      break;
      case 'FIRST_50':
        // Special scenario need to ask bhavesh how to distinguish all and first 50.
        this.selectAll = true;
        this.dataSource.data.forEach((data: OrderListMapperI) => (data.select = true));
      break;
      case 'SELECT_ALL':
          // Special scenario need to ask bhavesh how to distinguish all and first 50.
         this.selectAll = true;
         this.dataSource.data.forEach((data: OrderListMapperI) => (data.select = true));
      break;
      case 'DESELECT_ALL':
          this.selectAll = false;
          this.dataSource.data.forEach((data: OrderListMapperI) => (data.select = false));
      break;
      case 'SELECT_ALL_TOGGLE':
          this.selectAll = !this.selectAll;
          this.dataSource.data.forEach((data: OrderListMapperI) => (data.select = this.selectAll));
          selectType = this.selectAll ? 'SELECT_ALL' : 'DESELECT_ALL';
      break;
      default:
          this.selectAll = !this.selectAll;
          this.dataSource.data.forEach((data: OrderListMapperI) => (data.select = this.selectAll));
      break;
    }

    this.selectClicked.emit({data: this.dataSource.data, selectType});
  }

  /**
   * Toggles on select of favorite.
   *
   * @param {KanbanTableI} element
   * @returns {void}
   */
  public onFavoriteClick(element: OrderListMapperI): void {
    element.favorite = !element.favorite;

    this.onFavoriteToggle.emit(element);
  }

  /**
   * On column click, emit the colum name and the row selected.
   *
   * @param {OrderListMapperI} element
   * @param {string} columnName
   * @returns {void}
   */
  public onColumnClicked(element: OrderListMapperI, columnName: string): void {
    this.onColumnClick.emit({ columnName, rowSelected: element });
  }

  /**
   * On paginate emit event;
   *
   * @returns {void}
   */
  public paginate(event: any) {
    const paginateObj = {
      offset: event.pageIndex,
      limit: event.pageSize,
    };

    this.pageSize = event.pageSize;

    this.onPaginateFire.emit(paginateObj);
  }

  /**
   * Checks to see if divider should exist in activities column.
   *
   * @param {OrderListMapperI} tableRow
   * @returns {void}
   */
  public checkShouldHaveDivider(tableRow: OrderListMapperI){
    if(!isNaN(tableRow.tasksTotal) && !isNaN(tableRow.tasksDone)){
      return true;
    }

    return false;
  }

  /**
   * Updates the total price column based on what is selected on header
   * dropdown.
   *
   * @returns {void}
   */
  public updateTotalPriceSelectedColumn(menuItem: KeyValueI) {
    this.totalPriceSelectedColumn = menuItem;
  }

  /**
   * On material sort fire event.
   *
   * @returns {void}
   */
  public onListViewSort(event: Sort) {
    this.onSortFired.emit(event);
  }

  public getDateFormat(date :any, includeTime = false, excludeTime = false, convert = false){
    if(date == null || date == '' || date == '0000-00-00 00:00:00' || date == '0000-00-00' || date == '0000-00-00' || (String(date).indexOf("0000") > -1 && String(date).indexOf("+0000") < 0 )){
        return '';
    }
    if(convert){
      if(includeTime){
    return moment(moment.utc(date).local().toDate()).format(this.dateFormatString+' '+this.timeFormatString);
      }else{
    if(String(date).length > 10 && !excludeTime){
        return moment(moment.utc(date).local().toDate()).format(this.dateFormatString+' '+this.timeFormatString);
    }else{
        return moment(moment.utc(date).local().toDate()).format(this.dateFormatString);
    }
      }          
    }else{
      if(includeTime){
    return moment(date).format(this.dateFormatString+' '+this.timeFormatString);
      }else{
    if(String(date).length > 10 && !excludeTime){
        return moment(date).format(this.dateFormatString+' '+this.timeFormatString);
    }else{
        return moment(date).format(this.dateFormatString);
    }
      }      
    }
  }

  resyncQBOStatus(orderId: string) {
    this.onResyncQBOStatus.emit(orderId);
  }
}
